import { app } from '../../../../../../app';

app.service('ConfirmConvertModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (messageKey) => {
        return $uibModal.open({
            component: 'confirmConvert',
            resolve: {messageKey: () => messageKey}
        }).result;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/confirm-convert/confirm-convert.modal.js